module.exports = __webpack_public_path__ + "img/vip_bg_3.fb82a4ed.png";